import { render, staticRenderFns } from "./drop-file.vue?vue&type=template&id=0c78b3e6&"
import script from "./drop-file.vue?vue&type=script&lang=js&"
export * from "./drop-file.vue?vue&type=script&lang=js&"
import style0 from "./drop-file.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports